/**
 * Spacing tokens for padding, margin, and gap
 *
 * Usage pattern: Mobile typically uses one step smaller than desktop
 * Example: section (1.5rem) on desktop → component (1rem) on mobile
 */
export const spacing = {
  /** Space between inline elements (icon + text, badge padding) */
  inline: "0.5rem", // 8px

  /** Space between related elements in a group */
  element: "0.75rem", // 12px

  /** Internal padding of components, space between form fields */
  component: "1rem", // 16px

  /** Space between distinct sections within a page/modal */
  section: "1.5rem", // 24px

  /** Main content padding, space between major page areas */
  page: "2rem", // 32px

  /** Reserved space for fixed footers, large separations */
  footer: "4rem", // 64px
} as const;

export type SpacingToken = keyof typeof spacing;
